module.exports = __webpack_public_path__ + "img/161-ivory-coast.1c450059.svg";